/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/*
 * @Author: Sergiy Samborskiy
 * @Date: 2017-11-15 17:18:56
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2017-11-15 17:29:35
 */

import * as React from 'react';

import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import Visibility from 'material-ui/svg-icons/action/visibility';
import Star from 'material-ui/svg-icons/toggle/star';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';

export function PortItem(props) {
    const [showMarkMain, setShowMarkMain] = React.useState(false);

    const {
        child, isMainPort, isMainChildPort, toggleMainChildPort, toggleMainPort, removePort, showPort,
    } = props;

    if (!child) {
        return '';
    }

    /**
     * 
     * @param {MouseEvent} e 
     */
    const show = (e) => {
        e.preventDefault();
        setShowMarkMain(true);
    };

    /**
     * 
     * @param {MouseEvent} e 
     */
    const notShow = (e) => {
        e.preventDefault();
        setShowMarkMain(false);
    };
    
    return (
        <div 
            style={{ width: '100%', margin: 0 }} 
            onMouseOver={e => show(e)}
            onMouseLeave={e => notShow(e)}
        >
            <div
                style={{
                    width: '100%', fontSize: '12px', display: 'flex', alignItems: 'center', 
                }}
            >
                <Checkbox
                    checked={isMainChildPort}
                    style={{ width: '80%', display: 'block' }}
                    label={child.name}
                    onCheck={(e, value) => {
                        toggleMainChildPort(child, value);
                    }}
                />
                
                <IconButton 
                    onClick={() => {
                        toggleMainPort(child, !isMainPort);
                    }}
                >
                    {
                        isMainPort ?
                            <Star />
                            :
                            showMarkMain && 
                            <StarBorder />
                    }
                </IconButton>
                <IconButton onClick={() => {
                    showPort(child);
                }}
                >
                    <Visibility />
                </IconButton>
                <IconButton onClick={() => {
                    removePort(child);
                }}
                >
                    <NavigationClose />
                </IconButton>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Ports/PortItem.jsx